import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import classes from './StyledPaginationPanel.module.scss';

function BasicItemContainer({ active = false, clickHandler, disabled = false, children }) {
  return (
    <div
      data-testid="paginationitem"
      role="presentation"
      onClick={clickHandler}
      className={`${classes.basicItemContainer} ${active ? classes.active : ''} ${disabled ? classes.disabled : ''}`}
    >
      {children}
    </div>
  );
}

function StyledPaginationPanel(props) {
  const { total, active, setActive } = props;

  if (total < 2) return false;

  let isPrevEllipsis = false;
  const itemsLeftSideCount = active - 1;
  const itemsRightSideCount = total - active;

  return (
    <div className={classes.paginationContainer}>
      <BasicItemContainer
        clickHandler={() => {
          if (active > 1) setActive(active - 1);
        }}
        disabled={active === 1}
      >
        <ArrowBackIosNewIcon fontSize="inherit" />
      </BasicItemContainer>
      {Array.from({ length: total }, (_, index) => index + 1).map((item) => {
        if (
          item === 1 ||
          item === total ||
          item === active ||
          (itemsLeftSideCount <= 3 && item <= active) ||
          (itemsLeftSideCount > 3 && item === active - 1) ||
          (itemsRightSideCount <= 3 && item >= active) ||
          (itemsRightSideCount > 3 && item === active + 1) ||
          (itemsLeftSideCount < 3 && itemsRightSideCount > 3 && item - active <= 3 - itemsLeftSideCount) ||
          (itemsRightSideCount < 3 && itemsLeftSideCount > 3 && active - item <= 3 - itemsRightSideCount)
        ) {
          isPrevEllipsis = false;
          return (
            <BasicItemContainer key={item} active={item === active} clickHandler={() => setActive(item)}>
              {item}
            </BasicItemContainer>
          );
        }

        if (isPrevEllipsis) return null;
        isPrevEllipsis = true;
        return <MoreHorizIcon key={item} sx={{ color: '#737474' }} />;
      })}
      <BasicItemContainer
        clickHandler={() => {
          if (active < total) setActive(active + 1);
          return false;
        }}
        disabled={active === total}
      >
        <ArrowForwardIosIcon fontSize="inherit" />
      </BasicItemContainer>
    </div>
  );
}

export default StyledPaginationPanel;
